export interface OrdineVenditaImportRow {
  organizzazioneId?: number;
  campiUtente?: { [codice: string]: string | null };

  // Header
  rifOrdine: string;
  numRegistrazione?: string;
  annoOrdine?: string;
  bis?: string; // Feature 067/068: revisione "ordine bis" (visibile in anteprima)
  ragioneSocialeCliente: string;
  rifCliente?: string;
  commessa?: string;
  indirizzoConsegna?: string;
  zona?: string;
  // Feature 076: indirizzo strutturato RISOLTO mostrato in anteprima (file → Sede Principale → esistente),
  // valorizzato lato backend in AnalyzeAsync. Nomi 1:1 con OrdineVenditaImportRow / OrdineVenditaDto.
  indirizzo?: string;
  citta?: string;
  cap?: string;
  provincia?: string;
  nazione?: string;
  statoOrdine?: string;
  statoConsegna?: string;
  dataRegistrazione?: string;
  dataOrdine?: string;
  dataConsegna?: string;
  valuta?: string;
  rappresentante?: string;

  // Riga
  codiceArticolo?: string;
  varianteArt?: string;
  codiceMateriale?: string;
  anagraficaId?: string;
  quantita?: string;
  udM?: string;
  magUdM?: string;
  importoRiga?: string;
  note?: string;
}

export interface OrdineVenditaRowResult {
  rowNumber: number;
  isValid: boolean;
  data?: OrdineVenditaImportRow;
  errors: string[];

  // Feature 040: scarti Campi Utente non bloccanti (ambra) + flag ordine già esistente (badge upsert).
  warnings?: string[];
  existingRecord?: boolean;
}

export interface OrdineVenditaImportResult {
  totalRows: number;
  validRows: number;
  invalidRows: number;
  rows: OrdineVenditaRowResult[];

  // Feature 056 (issue #2881): anomalie a livello REPORT (non legate a una singola riga).
  //   - errors:   bloccanti (es. intestazioni duplicate) → la conferma è disabilitata finché non è vuota.
  //   - warnings: non bloccanti (es. colonna mappata ma assente dal file).
  errors?: string[];
  warnings?: string[];

  // Feature 102 (issue #3207): campi target del tracciato effettivamente acquisibili dal file (voci
  // Campi Utente come "CampoUtente.<slug>"). Guida il merge selettivo BE (round-trip integro alla Confirm)
  // e l'evidenza in anteprima delle colonne del tracciato (FR-019). Assente = report legacy → nessuna evidenza.
  mappedTargetFields?: string[];
}

// Feature 053 (DEC-008): l'enum è ora in _models/ModalitaSovrascrittura.ts (condiviso con import
// Anagrafiche). Ri-esportato qui per retro-compatibilità con gli import esistenti del flusso OdV.
export { ModalitaSovrascrittura } from './ModalitaSovrascrittura';
